import React, { useEffect, useState } from "react";

// TV Millionario's YOU WIN screen (public/tv-milionario/game/youwin/guy):
// the host with money flying, over everything but the footer. Each frame is
// a whole 800x491 picture with an empty number box; the amount is drawn in
// the box. In https://www.youtube.com/watch?v=qzZSNKlRcCg (114.2s) the clip
// is _yw_man1 001-015 then _yw_man2 001-016, looped, at 20fps.
//
// variant="girl" (game/youwin/girl, from a screenshot of the machine): the
// hostess over the reels, which stay in view behind her. _yw_woman1 (360
// wide, drawn at x 220) then _yw_woman2 (full width) loop at 20fps; both
// carry the number box (x 238-560, y 315-407) and a cut of the letters, and
// the full YOU * WIN (_yw_youwin, 37 frames of glint) goes on top at (132,204).

const YW = `${process.env.PUBLIC_URL}/tv-milionario/game/youwin/guy/refactored`;
const pad3 = (n) => String(n).padStart(3, "0");
const FRAMES = [
    ...Array.from({ length: 15 }, (_, i) => `${YW}/_yw_man1/_YW_MAN1_${pad3(i + 1)}.png`),
    ...Array.from({ length: 16 }, (_, i) => `${YW}/_yw_man2/_YW_MAN2_${pad3(i + 1)}.png`),
];
const FRAME_MS = 50;

const GIRL = `${process.env.PUBLIC_URL}/tv-milionario/game/youwin/girl/refactored`;
const GIRL_FRAMES = [
    ...Array.from({ length: 17 }, (_, i) => ({ src: `${GIRL}/_yw_woman1/sprite_${String(i).padStart(2, "0")}.png`, left: 220 })),
    ...Array.from({ length: 18 }, (_, i) => ({ src: `${GIRL}/_yw_woman2/sprite_${String(i).padStart(2, "0")}.png`, left: 0 })),
];
const GIRL_TEXT = Array.from({ length: 37 }, (_, i) => `${GIRL}/_yw_youwin/sprite_${String(i).padStart(2, "0")}.png`);

// How the amount pays out behind the screen, measured off the video
// (114.2s -> 118.1s, 41000 won): it creeps, then runs away — paid grows like
// e^(1.76 t) and is half the win at 3.9s, when the screen cuts back to the
// reels and the rest lands at once.
export const YOU_WIN_MS = 3900;
const GROWTH = 1.76; // per second
const PAID_AT_CUT = 0.5;
const SPAN = Math.exp(GROWTH * YOU_WIN_MS / 1000) - 1;
export const youWinPaidAt = (amount, ms) =>
    Math.floor(amount * PAID_AT_CUT * (Math.exp(GROWTH * Math.min(ms, YOU_WIN_MS) / 1000) - 1) / SPAN);

export const preloadYouWin = () => [...FRAMES, ...GIRL_FRAMES.map((f) => f.src), ...GIRL_TEXT]
    .forEach((s) => { const im = new Image(); im.src = s; });

const YouWin = ({ value, onSkip, variant = "guy" }) => {
    const [frame, setFrame] = useState(0);
    useEffect(() => {
        const id = setInterval(() => setFrame((f) => f + 1), FRAME_MS);
        return () => clearInterval(id);
    }, []);
    const amount = Math.max(0, Math.floor(Number(value) || 0));
    if (variant === "girl") {
        const g = GIRL_FRAMES[frame % GIRL_FRAMES.length];
        return (
            <div className="tvm-youwin girl" onClick={onSkip}>
                <img alt="" src={g.src} draggable={false} style={{ left: g.left }} />
                <img alt="" src={GIRL_TEXT[frame % GIRL_TEXT.length]} draggable={false} className="tvm-youwin-text" />
                <div className="tvm-youwin-num girl"><span>{amount}</span></div>
            </div>
        );
    }
    return (
        <div className="tvm-youwin" onClick={onSkip}>
            <img alt="" src={FRAMES[frame % FRAMES.length]} draggable={false} />
            {/* the box in the art: x 226-575, y 377-472 */}
            <div className="tvm-youwin-num"><span>{amount}</span></div>
        </div>
    );
};

export default YouWin;
